import { render, staticRenderFns } from "./PaymentNote.vue?vue&type=template&id=2b5fe668"
import script from "./PaymentNote.vue?vue&type=script&lang=js"
export * from "./PaymentNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports